module.exports = __webpack_public_path__ + "media/images/story/typo/aboutResort-d415e7df263440e7d33ff2b231642256.svg";